import { render, staticRenderFns } from "./guangz.vue?vue&type=template&id=0aa00418&"
import script from "./guangz.vue?vue&type=script&lang=js&"
export * from "./guangz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports